(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhp-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CLOSE_DELAY_MS = 150;
    var docListenersBound = false;

    function setMobilePanelA11y(panel, open) {
      if (open) {
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
      }
    }

    function findMobilePanelById(menu, id) {
      if (!menu || !id) return null;
      var foundPanel = null;
      menu.querySelectorAll('[data-vhp-mobile-panel]').forEach(function (panel) {
        if (panel.id === id) foundPanel = panel;
      });
      return foundPanel;
    }

    function getMobileRootPanel(menu) {
      return menu.querySelector('[data-vhp-mobile-panel-root]');
    }

    function getMobilePanelChain(menu, targetPanel) {
      var rootPanel = getMobileRootPanel(menu);
      var panel = targetPanel || rootPanel;
      var chain = [];

      while (panel && chain.indexOf(panel) === -1) {
        chain.unshift(panel);
        var parentId = panel.getAttribute('data-vhp-mobile-panel-parent');
        if (!parentId) break;
        panel = parentId === 'root' ? rootPanel : findMobilePanelById(menu, parentId);
      }

      if (rootPanel && chain.indexOf(rootPanel) === -1) {
        chain.unshift(rootPanel);
      }

      return chain;
    }

    function setActiveMobilePanel(menu, targetPanel) {
      if (!menu) return;
      var rootPanel = getMobileRootPanel(menu);
      var nextPanel = targetPanel || rootPanel;
      if (!nextPanel) return;

      var chain = getMobilePanelChain(menu, nextPanel);
      var activeIds = chain.map(function (panel) {
        return panel.id;
      }).filter(Boolean);

      menu.setAttribute('data-vhp-mobile-depth', Math.max(chain.length - 1, 0).toString());

      menu.querySelectorAll('[data-vhp-mobile-panel]').forEach(function (panel) {
        var isActive = panel === nextPanel;
        var isBefore = chain.indexOf(panel) !== -1 && !isActive;
        var wasActive = panel.classList.contains('is-active');

        panel.classList.toggle('is-active', isActive);
        panel.classList.toggle('is-before', isBefore);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('inert', '');
        }

        if (isActive && !wasActive && !panel.classList.contains('nav-mobile-panel--root')) {
          panel.style.transform = 'translate3d(100%, 0, 0)';
        } else if (!isActive) {
          panel.style.transform = '';
        }
      });

      menu.querySelectorAll('[data-vhp-mobile-panel-open]').forEach(function (trigger) {
        var controls = trigger.getAttribute('aria-controls');
        trigger.setAttribute('aria-expanded', activeIds.indexOf(controls) !== -1 ? 'true' : 'false');
      });

      if (!nextPanel.classList.contains('nav-mobile-panel--root')) {
        void nextPanel.offsetWidth;
        nextPanel.style.transform = '';
      }
    }

    function resetMobilePanels(menu) {
      setActiveMobilePanel(menu, getMobileRootPanel(menu));
    }

    function focusMobilePanel(panel) {
      if (!panel || panel.hasAttribute('inert')) return;
      var target = panel.querySelector('[data-vhp-mobile-panel-back], a, button');
      if (target) target.focus();
    }

    var PANEL_ANIM_MS = 320;

    function lockDesktopPanel(panel) {
      if (!panel) return;
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
    }

    function unlockDesktopPanel(panel) {
      if (!panel) return;
      panel.removeAttribute('inert');
      panel.setAttribute('aria-hidden', 'false');
    }

    function closeDesktopItem(item) {
      if (!item) return;
      var trigger = item.querySelector('[data-vhp-nav-trigger]');
      var panel = item.querySelector('[data-vhp-nav-panel-desktop]');
      if (item._vhpCloseTimer) {
        clearTimeout(item._vhpCloseTimer);
        item._vhpCloseTimer = null;
      }
      if (!item.classList.contains('is-open')) return;

      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      if (!panel) return;

      if (item._vhpPanelCloseTimer) clearTimeout(item._vhpPanelCloseTimer);
      item._vhpPanelCloseTimer = setTimeout(function () {
        if (!item.classList.contains('is-open')) {
          lockDesktopPanel(panel);
        }
        item._vhpPanelCloseTimer = null;
      }, PANEL_ANIM_MS);
    }

    function openDesktopItem(item) {
      if (!item) return;
      var trigger = item.querySelector('[data-vhp-nav-trigger]');
      var panel = item.querySelector('[data-vhp-nav-panel-desktop]');
      if (item._vhpCloseTimer) {
        clearTimeout(item._vhpCloseTimer);
        item._vhpCloseTimer = null;
      }
      if (item._vhpPanelCloseTimer) {
        clearTimeout(item._vhpPanelCloseTimer);
        item._vhpPanelCloseTimer = null;
      }

      unlockDesktopPanel(panel);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          item.classList.add('is-open');
        });
      });
    }

    function closeAllDesktopItems(root, exceptItem) {
      root.querySelectorAll('[data-vhp-nav-item]').forEach(function (item) {
        if (item !== exceptItem) closeDesktopItem(item);
      });
    }

    function closeNavRoot(root) {
      var toggle = root.querySelector('[data-vhp-nav-toggle]');
      var panel = root.querySelector('[data-vhp-nav-panel]');
      if (!toggle || !panel) return;
      resetMobilePanels(panel);
      toggle.classList.remove('open');
      panel.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Menü öffnen');
      setMobilePanelA11y(panel, false);
      closeAllDesktopItems(root);
    }

    function bindDocumentListenersOnce() {
      if (docListenersBound) return;
      docListenersBound = true;

      document.addEventListener('click', function (e) {
        document.querySelectorAll('.vhp-nav-root').forEach(function (root) {
          var toggle = root.querySelector('[data-vhp-nav-toggle]');
          if (toggle && toggle.classList.contains('open') && !root.contains(e.target)) {
            closeNavRoot(root);
          }
          if (!root.contains(e.target)) {
            closeAllDesktopItems(root);
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.vhp-nav-root').forEach(function (root) {
          var hadDesktopOpen = root.querySelector('[data-vhp-nav-item].is-open');
          closeAllDesktopItems(root);
          if (hadDesktopOpen) {
            e.preventDefault();
            return;
          }
          closeNavRoot(root);
        });
      });
    }

    function initDesktopMenus(root) {
      root.querySelectorAll('[data-vhp-nav-item]').forEach(function (item) {
        if (item.getAttribute('data-vhp-desktop-bound') === 'true') return;
        item.setAttribute('data-vhp-desktop-bound', 'true');

        var trigger = item.querySelector('[data-vhp-nav-trigger]');
        var panel = item.querySelector('[data-vhp-nav-panel-desktop]');
        if (!trigger || !panel) return;

        function scheduleClose() {
          if (item._vhpCloseTimer) clearTimeout(item._vhpCloseTimer);
          item._vhpCloseTimer = setTimeout(function () {
            closeDesktopItem(item);
          }, CLOSE_DELAY_MS);
        }

        function handleOpen() {
          closeAllDesktopItems(root, item);
          openDesktopItem(item);
        }

        item.addEventListener('mouseenter', handleOpen);
        item.addEventListener('mouseleave', scheduleClose);
        panel.addEventListener('mouseenter', handleOpen);
        panel.addEventListener('mouseleave', scheduleClose);

        item.addEventListener('focusin', handleOpen);
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) scheduleClose();
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            closeDesktopItem(item);
            trigger.focus();
          }
        });
      });
    }

    function initMobilePanels(menu) {
      resetMobilePanels(menu);

      menu.querySelectorAll('[data-vhp-mobile-panel-open]').forEach(function (trigger) {
        if (trigger.getAttribute('data-vhp-mobile-panel-bound') === 'true') return;
        trigger.setAttribute('data-vhp-mobile-panel-bound', 'true');

        trigger.addEventListener('click', function () {
          var targetPanel = findMobilePanelById(menu, trigger.getAttribute('data-vhp-mobile-panel-open'));
          if (!targetPanel) return;
          setActiveMobilePanel(menu, targetPanel);
          focusMobilePanel(targetPanel);
        });
      });

      menu.querySelectorAll('[data-vhp-mobile-panel-back]').forEach(function (backButton) {
        if (backButton.getAttribute('data-vhp-mobile-panel-bound') === 'true') return;
        backButton.setAttribute('data-vhp-mobile-panel-bound', 'true');

        backButton.addEventListener('click', function () {
          var activePanel = menu.querySelector('[data-vhp-mobile-panel].is-active');
          var parentId = activePanel && activePanel.getAttribute('data-vhp-mobile-panel-parent');
          var targetPanel = parentId === 'root' ? getMobileRootPanel(menu) : findMobilePanelById(menu, parentId);
          var opener = activePanel ? menu.querySelector('[data-vhp-mobile-panel-open="' + activePanel.id + '"]') : null;

          setActiveMobilePanel(menu, targetPanel);

          if (opener && !opener.closest('[inert]')) {
            opener.focus();
          } else {
            focusMobilePanel(targetPanel);
          }
        });
      });
    }

    function initVhpNav(root) {
      if (root.getAttribute('data-vhp-nav-initialized') === 'true') return;
      root.setAttribute('data-vhp-nav-initialized', 'true');

      var toggle = root.querySelector('[data-vhp-nav-toggle]');
      var panel = root.querySelector('[data-vhp-nav-panel]');

      bindDocumentListenersOnce();
      initDesktopMenus(root);

      if (!toggle || !panel) return;
      initMobilePanels(panel);

      function setMobileOpen(open) {
        resetMobilePanels(panel);
        toggle.classList.toggle('open', open);
        panel.classList.toggle('open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
        setMobilePanelA11y(panel, open);
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        setMobileOpen(!toggle.classList.contains('open'));
      });
    }

    function resetAndInit(root) {
      root.removeAttribute('data-vhp-nav-initialized');
      root.querySelectorAll('[data-vhp-desktop-bound]').forEach(function (el) {
        el.removeAttribute('data-vhp-desktop-bound');
      });
      initVhpNav(root);
    }

    document.querySelectorAll('.vhp-nav-root').forEach(initVhpNav);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector && e.target.querySelector('.vhp-nav-root');
      if (root) resetAndInit(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
